import { NumberWithUnit, NumberWithUnitConstructor, UnitSource } from "./NumberWithUnit";
import { Unit } from "./Unit";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";
import { VolumeConversionFactors } from "./VolumeConversionFactors";
import { VolumeUnits } from "./VolumeUnits";

export class Volume extends NumberWithUnit {
    protected override get cls(): NumberWithUnitConstructor {
        return Volume;
    }

    public override get unitGroup(): VolumeUnits {
        return VolumeUnits.singleton;
    }

    public override convert(targetUnit: UnitSource): number {
        const targetUnitAbbreviation = Unit.resolveAbbreviation(targetUnit);
        return this.convertWithPrecision(targetUnitAbbreviation, 2);
    }

    public override getConversionFactors(): UnitConversionFactorGroup {
        return VolumeConversionFactors.get();
    }
}
